import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${props => (props.isReaded ? '#f5f5f5' : '#FFF')};
  padding: 15px;
  margin-top: 15px;
  ${props => (props.isReaded && 'border: 2px solid #FFF;')}


  .soma-button {
    display: flex;
    padding: 15px;
    margin-top: 12px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .title {
    display: flex;
    flex-direction: row;

    .soma-description {
      margin-left: 10px;
      color: #000;
    }
  }

  .date {
    min-width: fit-content;
    padding-left: 10px;
  }
`;

export const Content = styled.div`
  margin-top: 12px;

  .soma-paragraph {
    font-size: 14px;
  }
`;
